
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class VerificationSign extends Vue {
  @Prop( { default: false })
  private success!: boolean;
}
